<template>
  <div v-if="!tsNum" class="exp empty">—</div>
  <div v-else :class="['exp', cls]">
    <div>{{ formatted }}</div>
    <small>{{ daysLeft < 0 ? '已过期 ' + (-daysLeft) + 'd' : '剩 ' + daysLeft + 'd' }}</small>
  </div>
</template>

<script>
// SYNC WITH src/views/domains/components/ExpiryCell.vue
import dayjs from 'dayjs'
export default {
  name: 'ExpiryCell',
  props: { ts: { type: [Number, String], default: null } },
  computed: {
    tsNum() { return this.ts ? Number(this.ts) : 0 },
    daysLeft() { return Math.floor((this.tsNum * 1000 - Date.now()) / 86400000) },
    cls() {
      if (!this.tsNum) return 'empty'
      if (this.daysLeft < 0) return 'expired'
      if (this.daysLeft <= 30) return 'urgent'
      if (this.daysLeft <= 90) return 'warn'
      return ''
    },
    formatted() { return this.tsNum ? dayjs(this.tsNum * 1000).format('YYYY-MM-DD') : '' },
  },
}
</script>

<style scoped>
.exp small { color: inherit; opacity: 0.7; }
.exp.expired { color: #ff4d4f; font-weight: 600; }
.exp.urgent  { color: #fa541c; }
.exp.warn    { color: #faad14; }
.exp.empty   { color: #ccc; }
</style>
